import { Component } from "react";

class ErrorBoundary extends Component<{ children: any }> {
  state = { error: "", errorInfo: { componentStack: [] } };
  constructor(props: any) {
    super(props);
    this.state = { error: "", errorInfo: { componentStack: [] } };
  }

  componentDidCatch(error: any, errorInfo: any) {
    this.setState({
      error: error,
      errorInfo: errorInfo,
    });
  }

  render() {
    if (this.state.error) {
      return (
        <div>
          <h2>Error Occurred</h2>
          {this.state.error && (
            <details>
              {this.state?.error?.toString?.()}
              <br />
              {this.state.errorInfo.componentStack}
            </details>
          )}
        </div>
      );
    }
    return this.props?.children;
  }
}

export default ErrorBoundary;
